import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { has, isNil } from 'lodash-es';

import { CoreConfig } from '../../core.module';

@Injectable({
  providedIn: 'root'
})
export class ReportApiService {
  private coreConfig = inject<CoreConfig>(CoreConfig);
  private httpClient = inject(HttpClient);

  sendRequest(
    method: string,
    url: string,
    options?: {
      body?: unknown;
      context?: HttpContext;
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      observe?: 'body' | 'events' | 'response';
      params?:
        | HttpParams
        | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
          };
      reportProgress?: boolean;
      responseType?: 'arraybuffer' | 'blob' | 'text' | 'json';
      transferCache?:
        | {
            includeHeaders?: string[];
          }
        | boolean;
      withCredentials?: boolean;
    }
  ) {
    const headers = new HttpHeaders()
      .set('x-app-id', this.coreConfig.report.appId)
      .set('x-app-secret', this.coreConfig.report.appSecret);

    return this.httpClient.request(method, `${this.coreConfig.report.baseUrl}${url}`, {
      ...(options || {}),
      headers
    });
  }

  getQueryParams(parameters?: { [key: string]: string | number | boolean | null }) {
    let params = new HttpParams();
    for (const key in parameters) {
      if (has(parameters, key) && !isNil(parameters[key])) {
        params = params.append(key, parameters[key]);
      }
    }
    return params;
  }
}
